import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export function BannerCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const banners = [{
    image: 'https://cdn.magicpatterns.com/uploads/wNjJrHW19RzU7ZLnbmeqbS/Banner_02.jpg',
    alt: 'Nada es para siempre. Ni tu audición.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/8Xo5gdoLxsKJEqPvexzVG4/banner_03.jpg',
    alt: 'Para las almas solitarias - 50% OFF llevando 1 unidad'
  }];
  useEffect(() => {
    const timer = setInterval(() => {
      setDirection(1);
      setCurrentIndex(prev => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  const goToNext = () => {
    setDirection(1);
    setCurrentIndex(prev => (prev + 1) % banners.length);
  };
  const goToPrev = () => {
    setDirection(-1);
    setCurrentIndex(prev => (prev - 1 + banners.length) % banners.length);
  };
  const slideVariants = {
    enter: (dir: number) => ({
      x: dir > 0 ? '100%' : '-100%',
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (dir: number) => ({
      x: dir > 0 ? '-100%' : '100%',
      opacity: 0
    })
  };
  return <section className="relative w-full bg-black" data-id="element-81">
      <div className="relative w-full" data-id="element-82">
        <div className="relative w-full overflow-hidden" data-id="element-83">
          <AnimatePresence mode="wait" custom={direction} data-id="element-84">
            <motion.img key={currentIndex} src={banners[currentIndex].image} alt={banners[currentIndex].alt} className="w-full h-auto object-contain" custom={direction} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
            x: {
              type: 'spring',
              stiffness: 400,
              damping: 35
            },
            opacity: {
              duration: 0.3
            }
          }} data-id="element-85" />
          </AnimatePresence>

          {/* Navigation Buttons */}
          <button onClick={goToPrev} className="absolute left-4 top-1/2 z-10 -translate-y-1/2 rounded-full bg-black/30 p-2 text-white backdrop-blur-sm transition-all hover:bg-black/50 focus:outline-none focus:ring-2 focus:ring-white sm:left-8" aria-label="Banner anterior" data-id="element-86">
            <ChevronLeft className="h-6 w-6" data-id="element-87" />
          </button>

          <button onClick={goToNext} className="absolute right-4 top-1/2 z-10 -translate-y-1/2 rounded-full bg-black/30 p-2 text-white backdrop-blur-sm transition-all hover:bg-black/50 focus:outline-none focus:ring-2 focus:ring-white sm:right-8" aria-label="Siguiente banner" data-id="element-88">
            <ChevronRight className="h-6 w-6" data-id="element-89" />
          </button>

          {/* Dots Indicator */}
          <div className="absolute bottom-4 left-1/2 z-10 flex -translate-x-1/2 gap-2 sm:bottom-6" data-id="element-90">
            {banners.map((_, index) => <button key={index} onClick={() => {
            setDirection(index > currentIndex ? 1 : -1);
            setCurrentIndex(index);
          }} className={`h-2 rounded-full transition-all ${index === currentIndex ? 'w-8 bg-white' : 'w-2 bg-white/50 hover:bg-white/75'}`} aria-label={`Ir al banner ${index + 1}`} data-id="element-91" />)}
          </div>
        </div>
      </div>
    </section>;
}